<select [(ngModel)]="selectedAttribute" (ngModelChange)="AttributeSelected()" class="form-select">
  <option value="0" selected>Select an attribute</option>
  <ng-container *ngFor="let attr of attributes">
    <option *ngIf="attribute !== attr.id" [innerHTML]="attr.label" [value]="attr.id"></option>
  </ng-container>

</select>
